export default {

    success: 200,
}